/**
 * Checks to see if we are currently executing in the browser as some of our code
 * shouldn't execute on the server.
 * @example
 * isInBrowserEnvironment()
 * // returns true
 */
export const isInBrowserEnvironment = () => typeof window !== 'undefined';
